import { useEffect, useState } from 'react'

const FONT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"

export default function SpeechBubble({ text, streaming, visible, onClick, position = 'bottom-left' }) {
  const [mounted, setMounted] = useState(false)
  const [exiting, setExiting] = useState(false)

  useEffect(() => {
    if (visible && !mounted) {
      setExiting(false)
      setMounted(true)
    }
    if (!visible && mounted) {
      setExiting(true)
      const t = setTimeout(() => {
        setMounted(false)
        setExiting(false)
      }, 280)
      return () => clearTimeout(t)
    }
  }, [visible])

  if (!mounted) return null

  const containerStyle = {
    position: 'relative',
    marginBottom: 12,
    maxWidth: '100%',
    transition: 'opacity 0.28s ease, transform 0.28s ease',
    opacity: exiting ? 0 : 1,
    transform: exiting ? 'translateY(8px)' : 'translateY(0)',
    animation: !exiting ? 'aa-bubble-in 0.28s ease forwards' : undefined,
  }

  const bubbleStyle = {
    background: '#ffffff',
    borderRadius: 18,
    padding: '14px 18px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.13), 0 1px 4px rgba(0,0,0,0.07)',
    fontFamily: FONT,
    fontSize: 14,
    lineHeight: 1.55,
    color: '#1a1a2e',
    cursor: 'pointer',
    userSelect: 'none',
    position: 'relative',
    wordBreak: 'break-word',
  }

  const tailStyle = position === 'bottom-right'
    ? {
        position: 'absolute',
        bottom: -10,
        right: 28,
        width: 0,
        height: 0,
        borderLeft: '6px solid transparent',
        borderRight: '10px solid transparent',
        borderTop: '10px solid #ffffff',
        filter: 'drop-shadow(0 2px 2px rgba(0,0,0,0.07))',
      }
    : {
        position: 'absolute',
        bottom: -10,
        left: 28,
        width: 0,
        height: 0,
        borderLeft: '10px solid transparent',
        borderRight: '6px solid transparent',
        borderTop: '10px solid #ffffff',
        filter: 'drop-shadow(0 2px 2px rgba(0,0,0,0.07))',
      }

  const cursorStyle = {
    display: 'inline-block',
    width: 2,
    height: '1em',
    background: '#10b981',
    marginLeft: 2,
    verticalAlign: 'text-bottom',
    animation: 'aa-blink 0.9s step-end infinite',
  }

  return (
    <>
      <style>{`
        @keyframes aa-bubble-in {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes aa-blink {
          0%, 100% { opacity: 1; }
          50%       { opacity: 0; }
        }
      `}</style>
      <div style={containerStyle} onClick={onClick}>
        <div style={bubbleStyle}>
          <span style={{ whiteSpace: 'pre-wrap' }}>{(text ?? '').replace(/\n{2,}/g, '\n').trim()}</span>
          {streaming && <span style={cursorStyle} />}
        </div>
        <div style={tailStyle} />
      </div>
    </>
  )
}
